<div [class.bottom-padding-md-sm]="showFilterCol" class="general-container">
  <css-loading-indicator [show]="loading$ | async"></css-loading-indicator>
  <div class="row">
    <h1 *ngIf="
      locale === 'en-us' ||
      locale === 'en-gb' ||
      locale === 'en-ca' ||
      locale === 'en-au' ||
      locale === 'en-sg' ||
      locale === 'en-in' || 
      locale === 'en-my' ||
      locale === 'en-ph' ||
      locale === 'en-my'
      " class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      {{ "shop" | translate }}
      <span class="">{{ "geforce" | translate }}</span>
      {{ "graphics_cards" | translate }}
    </h1>

    <h1 *ngIf="
        locale === 'nl-nl' ||
        locale === 'da-dk' ||
        locale === 'nb-no' ||
        locale === 'sv-se' ||
        locale === 'fi-fi'
      " class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      <span class="">{{ "shop_geforce_graphics_cards" | translate }}</span>
    </h1>
    <h1 *ngIf="locale === 'zh-tw'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      <span class="">{{ "shop_geforce_graphics_cards" | translate }}</span>
    </h1>
    <h1 *ngIf="locale === 'it-it'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      {{ "shop" | translate }}
      <span class="">{{ "geforce" | translate }}</span>
      {{ "graphics_cards" | translate }}
    </h1>

    <h1 *ngIf="locale === 'de-de'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      <span class="">{{ "geforce" | translate }}</span>
      {{ "graphics_cards" | translate }} {{ "shop" | translate }}
    </h1>

    <h1 *ngIf="locale === 'fr-fr' || locale === 'fr-ca'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      {{ "shop" | translate }}
      {{ "graphics_cards" | translate }}
      <span class="">{{ "geforce" | translate }}</span>
      {{ "graphics_cards_last" | translate }}
    </h1>

    <h1 *ngIf="locale === 'pl-pl'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      
      {{ "graphics_cards" | translate }} 
    </h1>

    <h1 *ngIf="locale === 'es-es'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      <span class="">{{ "geforce" | translate }}</span>
      {{ "graphics_cards" | translate }} {{ "shop" | translate }}
    </h1>

    <h1 *ngIf="locale === 'es-mx'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      <!--  <span class="">{{ 'geforce' | translate }}</span> -->
      {{ "graphics_cards" | translate }}
      <!-- {{ 'shop' | translate }} -->
    </h1>
    <h1 *ngIf="locale === 'ko-kr'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      {{ "graphics_cards" | translate }}
    </h1>
     <h1 *ngIf="locale === 'pt-br'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      {{ "shop_geforce_graphics_cards" | translate }}
    </h1>
    <h1 *ngIf="locale === 'ru-ru'" class="shop-geforce-graphics-cards-header h1-like-h2 h--medium"
      [class.hide-shop-geforce-graphics-cards-header]="showFilterCol" style="padding-bottom: 30px;">
      {{ "shop_title" | translate }}
      <span *ngIf="locale !== 'ru-ru'" class="">{{
        "geforce" | translate
        }}</span>
    </h1>

    <!-- ///// Filter Column -->
    <div [class.show-filter-col]="showFilterCol" class="filter-col small-12 medium-12 column">
      <div class="filter-container">
        <div class="filter-close-button-container">
          <button type="button" class="filter-close-button" (click)="onFilterCloseButtonClick()"></button>
        </div>
        <product-filters [screenWidth]="screenWidth" [productFilter]="productFilter$ | async"
          (filterChange)="onFilterChange($event)" (clearFilter)="onClearFilter(false)"
          (toggleReset)="toggleMobileFilterReset($event)"></product-filters>
      </div>
    </div>
    <!-- ///// Right Column -->
    <div [class.hide-main-col]="!showMainCol" class="main-col small-12 medium-12 column">
      <div id="mainCont" class="main-container">
        <search #searchComp (viewType)="productDetails.sendData($event)" [totalProducts]="totalProducts$ | async"
          [productSort]="productSort$ | async" [productSearch]="productSearch$ | async" [locale]="locale$ | async">
        </search>
        <suggested-product [screenWidth]="screenWidth" [suggestedProduct]="suggestedProduct$ | async"
          [totalProducts]="totalProducts$ | async" [productSearchTerm]="productSearch$ | async"></suggested-product>

        <!--- <product-filter-crumbs></product-filter-crumbs> ---->

        <featured-product [screenWidth]="screenWidth" (fpLoaded)="productDetails.fpLoaded($event)"
          [suggestedProduct]="suggestedProduct$ | async" [productCompare]="productCompare$ | async"
          (hatchOverlayDisplay)="showHatchOverlay($event)"></featured-product>
        <product-details #productDetails (curViewType)="searchComp.setLayoutType($event)" [screenWidth]="screenWidth"
          [productCompare]="productCompare$ | async" (hatchOverlayDisplay)="showHatchOverlay($event)"></product-details>
        <load-more [locale]="locale" [limit]="productSearchCriteria.limit" [page]="productSearchCriteria.page"
          [totalProducts]="totalProducts$ | async" (onPaging)="onPaging($event)" [isFeaturedProductIncludedInCount]="
            isFeaturedProductIncludedInCount$ | async
          "></load-more>
      </div>
    </div>
  </div>
  <div [class.hide-footer]="
      showFilterCol && (screenWidth === 'MD' || screenWidth === 'SM')
    " class="outer-footer-container">
    <footer></footer>
  </div>
</div>
<div id="filterCompareCont" [class.hide-filter-compare]="!showFilterCompareButtons"
  class="filter-compare-buttons-main-container clearfix">
  <div class="filter-compare-buttons-container clearfix">
    <div [class.normal-z]="useNormalZIndex" class="filter-button-container" (click)="onFilterButtonClick()">
      <button type="button" class="filter-button">
        {{ "filter" | translate }}
      </button>
    </div>
    <compare-overlay [screenWidth]="screenWidth" [productCompare]="productCompare$ | async"
      (transitionEnd)="onCompareOverlayTransitionEnd($event)"></compare-overlay>
  </div>
</div>

<!-- /////------------ Apply and Reset filter buttons for the Tablet and Mobile view -----------///// -->
<div *ngIf="showFilterCol" class="product-footer-container">
  <input type="submit" value="{{ 'reset_filter' | translate }}"
    [class.reset-filters-disabled]="disableMobileFilterReset" class="product-footer-input reset-filters-input"
    (click)="onClearFilter(false)" />
  <input type="submit" value="{{ 'apply' | translate }}" class="product-footer-input apply-filters-input"
    (click)="applyFilter()" />
</div>
<hatch-overlay [showSpinner]="retailInfoLoading$ | async" [winPageYOffset]="winPageYOffset"
  [hatchOverlayDisplay]="hatchOverlayDisplay" [retailInfo]="retailInfo$ | async"
  [productDetail]="productDetail"></hatch-overlay>
